import { useCallback, useState } from 'react'

export const useFormFieldsManager = () => {
    const [fieldStates, setFieldStates] = useState([]);

    const updateFieldStatesByForm = useCallback((state = []) => {
        setFieldStates(state);
    }, []);

    const updateFieldState = useCallback(({ value, idChild, isDelete = false }) => {
        setFieldStates(prevFieldStates => {
            let newFieldStates = [...prevFieldStates];
            if (isDelete) {
                newFieldStates = newFieldStates.filter((_, index) => index !== idChild);
            } else {
                newFieldStates[idChild] = value;
            }
            return newFieldStates;
        });
    }, []);

    return {
        fieldStates,
        updateFieldStatesByForm,
        updateFieldState,
    };
};